// extracted by mini-css-extract-plugin
export default {"textTotal":"TotalService_textTotal__qDlan"};